<template>
    <tr class="prospectus-info-row">
        <td class="prospectus-info-td" :colspan="prospectusTypesWithListing.includes(lastSearchParams.ProspectusType) || lastSearchParams.ProspectusType === undefined ? 5 : 4">
            <div class="prospectus-info-div row">
                <div class="clearfix">
                    <div class="col">

                        <template v-if="prospectus.prospectusType === 4">

                            <table class="supplements prospectus-item-info-table">
                                <thead>
                                    <tr>
                                        <td>{{conf.translations.securitiestype}}</td>
                                        <td>{{conf.translations.competentauthority}}</td>
                                        <td>{{conf.translations.prospectusid}}</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {{translatedInfo(prospectus,"additionalInfo")}}
                                        </td>
                                        <td>
                                            {{prospectus.competentAuthority}}
                                        </td>
                                        <td>{{prospectus.nationalIdentifier}}</td>
                                    </tr>
                                </tbody>
                            </table>


                        </template>
                        <ul v-else class="prospectus">
                            <h4>{{conf.translations.prospectus}}</h4>
                            <li v-for="file in prospectus.prospectusFiles.concat().sort((a, b) => a.orderNumber - b.orderNumber)" :key="file.fileId">
                                <a @click.prevent="LoadFile(file)" :title="file.fileName" href="#">{{file.fileName}}</a><div v-show="IsFileLoading(file.fileId)" class="loading-spinner" />
                            </li>
                        </ul>
                    </div>
                    <!--<template v-if="prospectus.acquiringCompany && prospectus.mergingCompanies.length > 0">
            <div class="col right">
                <h4>{{conf.translations.mergingcompanies}}</h4>
                <ul>
                    <li v-for="company in prospectus.mergingCompanies" :key="company">
                        {{company}}
                    </li>
                </ul>
            </div>
            <div class="col right">
                <h4>{{conf.translations.acquiringcompany}}</h4>
                <ul>
                    <li>{{prospectus.acquiringCompany}}</li>
                </ul>
            </div>
        </template>-->
                    <!--<template v-if="prospectus.offeree && prospectus.offeror">
            <div class="col right">
                <h4>{{conf.translations.offeree}}</h4>
                <ul>
                    <li>{{prospectus.offeree}}</li>
                </ul>
            </div>
            <div class="col right">
                <h4>{{conf.translations.offeror}}</h4>
                <ul>
                    <li>{{prospectus.offeror}}</li>
                </ul>
            </div>
        </template>-->
                    <!--<template v-if="prospectus.acquiringCompany && prospectus.dividingCompany">
            <div class="col right">
                <h4>{{conf.translations.acquiringcompanies}}</h4>
                <ul>
                    <li>{{prospectus.acquiringCompany}}</li>
                </ul>
            </div>
            <div class="col right">
                <h4>{{conf.translations.dividingcompany}}</h4>
                <ul>
                    <li>{{prospectus.dividingCompany}}</li>
                </ul>
            </div>
        </template>-->

                </div>

                <template v-if="prospectus.supplementFiles && prospectus.supplementFiles.length > 0">
                    <!--<h4>{{conf.translations.supplements}}</h4>-->
                    <!--
    <ul class="supplements">
        <li v-for="supplement in prospectus.supplements" :key="supplement.fileId">
            <a @click.prevent="LoadFile(supplement)" href="#" :title="supplement.fileName">{{supplement.fileDisplayName}}</a><div v-show="IsFileLoading(supplement.fileId)" class="loading-spinner" />
        </li>
    </ul> -->
                    <table class="supplements prospectus-item-info-table">
                        <thead>
                            <tr>
                                <td>{{conf.translations.supplements}}</td>
                                <td>{{conf.translations.approvalDate}}</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="supplement in prospectus.supplementFiles.concat().sort((a, b) => a.orderNumber - b.orderNumber)" :key="supplement.fileId">
                                <td>
                                    <a @click.prevent="LoadFile(supplement)" href="#" :title="supplement.fileName">{{supplement.fileName}}</a><div v-show="IsFileLoading(supplement.fileId)" class="loading-spinner" />
                                </td>
                                <td>{{FormatDate(supplement.supplementApprovalDate)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>
                <template v-if="prospectus.referencedFiles && prospectus.referencedFiles.length > 0">
                    <h4>{{conf.translations.documentsIncorporatedByReference}}</h4>
                    <ul class="documents-incorporated-by-reference">
                        <li v-for="doc in prospectus.referencedFiles" :key="doc.fileid">
                            <a @click.prevent="LoadFile(doc)" :title="doc.filename" href="#">{{doc.fileName}}</a><div v-show="IsFileLoading(doc.fileid)" class="loading-spinner" />
                        </li>
                    </ul>
                    <!--<table class="documentsincorporatedbyreference prospectus-item-info-table">
      <thead>
        <tr>
          <td>{{conf.translations.documentsincorporatedbyreference}}</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="doc in prospectus.documentsincorporatedbyreference.concat().sort((a, b) => a.ordernumber - b.ordernumber)" :key="doc.fileid">
          <td>
            <a @click.prevent="loadfile(doc)" href="#" :title="doc.filename">{{doc.filedisplayname}}</a><div v-show="IsFileLoading(doc.fileid)" class="loading-spinner" />
          </td>
        </tr>
      </tbody>
    </table>-->
                </template>

                <template v-if="prospectus.finalTermsFiles && prospectus.finalTermsFiles.length > 0">
                    <h4>{{conf.translations.finalTerms}}</h4>
                    <ul class="documents-incorporated-by-reference">
                        <li v-for="doc in prospectus.finalTermsFiles" :key="doc.fileid">
                            <a @click.prevent="LoadFile(doc)" :title="doc.filename" href="#">{{doc.fileName}}</a><div v-show="IsFileLoading(doc.fileid)" class="loading-spinner" />
                        </li>
                    </ul>

                </template>

                <template v-if="prospectus.notificationSupplements && prospectus.notificationSupplements.length > 0">
                <table class="term-sheet-for-bonds prospectus-item-info-table">
                    <thead>
                        <tr>
                            <td>{{conf.translations.supplements}}</td>
                            <td>{{conf.translations.approvalDate}}</td>
                          
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="supplement in prospectus.notificationSupplements.concat().sort((a, b) => a.orderNumber - b.orderNumber)" :key="supplement.fileId">
                            
                            <td>{{supplement.supplementName}}</td>
                            <td>{{FormatDate(supplement.supplementDate)}}</td>
                            
                            
                        </tr>
                    </tbody>
                </table>
            </template>
                <!--<template v-if="prospectus.termSheetForBonds && prospectus.termSheetForBonds.length > 0">
        <table class="term-sheet-for-bonds prospectus-item-info-table">
            <thead>
                <tr>
                    <td>{{conf.translations.termSheetForBonds}}</td>
                    <td>{{conf.translations.loanPeriod}}</td>
                    <td>{{conf.translations.basisOfInterest}}</td>
                    <td>{{conf.translations.listed}}</td>
                    <td>{{conf.translations.finalTerms}}</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="sheet in prospectus.termSheetForBonds.concat().sort((a, b) => a.orderNumber - b.orderNumber)" :key="sheet.fileId">
                    <td>
                        <a @click.prevent="LoadFile(sheet)" :title="sheet.fileName" href="#">{{sheet.fileDisplayName}}</a>
                        <div v-show="IsFileLoading(sheet.fileId)" class="loading-spinner" />
                    </td>
                    <td>{{formatDateSpan(sheet.loanPeriodBegin, sheet.loanPeriodEnd)}}</td>
                    <td>{{sheet.basisOfInterest}}</td>
                    <td>{{YesNo(sheet.listed)}}</td>
                    <td>
                        <a v-if="sheet.finalTermId != 0" @click.prevent="LoadFile({fileId: sheet.finalTermId, fileType: sheet.finalTermType})" :title="sheet.finalTermsName" href="#">{{sheet.finalTermsDisplayName}}</a>
                        <div v-show="IsFileLoading(sheet.fileId)" class="loading-spinner" />
                    </td>
                </tr>
            </tbody>
        </table>
    </template>-->
            </div>
        </td>
    </tr>
</template>

<script>
    import { mapState, mapActions, mapGetters } from "vuex";

    export default {
        methods: {
            ...mapActions(["LoadFile"]),
            formatDateSpan(beginDate, endDate) {
                let output = "";
                if (beginDate)
                    output += this.FormatDate(beginDate) + " - ";
                if (endDate)
                    output += this.FormatDate(endDate);
                return output;
            },
            
            translatedInfo: function (prospectus,fieldName) {
                var lang = this.conf.language == "sv" ? "SE" : this.conf.language.toUpperCase();

                if (fieldName == null) {
                    fieldName = (prospectus.prospectusType == 3 || prospectus.prospectusType == 4) ? "securityType" : "additionalInfo";
                }
                return eval("prospectus." + fieldName + lang);
            }
        },
        props: {
            prospectus: {},
        },
        computed: {
            ...mapGetters(["LocaleString", "IsFileLoading", "YesNo", "FormatDate"]),
            ...mapState(["conf", "prospectusTypesWithListing", "lastSearchParams", "currentlyLoadingFiles"])
        }
    }
</script>

<style lang="scss" scoped>
</style>